<template>
    <v-data-table
        @click:row="handleClick"
        dense
        v-model="selected"
        show-select
        :loading="loading"
        :headers="headers"
        :items="Clientes"
        :search="search"
        :item-class="getRowClass"
        :items-per-page="100"
        item-key="id"
        :options.sync="options"
        class="elevation-1"
        :sort-by="['nombre']"
        :sort-desc="[false]"
        @update:options="onOptionsUpdate"
        :footer-props="{
            'items-per-page-options': [100, 500],
        }"
        :server-items-length="total_cliente"
        @update:items-per-page="ChangeSize"
        @pagination="ChangePage"
    >
    </v-data-table>
</template>
<script>
import { debounce } from "../../../helpers";
import BusquedaCliente from "./BusquedaCliente.vue";
import FilterComponentVue from "../../../components/general/FilterComponent.vue";
export default {
    props: ["filterString"],
    data() {
        return {
            agentes: [],
            filtros_prueba: {},
            filter_headers: [
                {
                    title: "Fecha",
                    type: "date",
                    active: false,
                    model: "fecha",
                },
                {
                    title: "Agente",
                    type: "select",
                    active: false,
                    model: "agente",
                    item_text: "nombre",
                    item_value: "id",
                },
                {
                    title: "Estado",
                    type: "select",
                    active: false,
                    model: "estado",
                    item_text: "nombre",
                    item_value: "id",
                },
            ],
            agentes: [],
            options: {},
            sorted: true,
            show_busqueda: false,
            filtros: {
                validacion: 0,
            },
            all_selected: false,
            selected: [],
            search: "",
            page: 1,
            loading: false,
            busqueda: "buscar",
            cantidad: 100,
            total_cliente: -1,
            headers_agente: [
                {
                    text: "#",
                    value: "id",
                    sortable: true,
                },
                {
                    text: "Nombre",
                    value: "nombre_comercial",
                    sortable: false,
                },
                { text: "Fecha de alta", value: "created_at", sortable: false },
                { text: "Estado", value: "estado.nombre", sortable: false },
                { text: "CIF/NIF", value: "cif", sortable: false },

                {
                    text: "Producto interesado",
                    value: "interes",
                    sortable: false,
                },
            ],
            headers: [
                {
                    text: "Cliente",
                    value: "cliente.nombre_comercial",
                },
                {
                    text: "Agente",
                    value: "agente.nombre",
                },
                {
                    text: "Estado",
                    value: "estado.nombre",
                },
                {
                    text: "Interesado",
                    value: "interesado.nombre",
                },
                {
                    text: "¿Cómo nos conocieron?",
                    value: "cliente_conocidos.name",
                },
                {
                    text: "Acciones",
                    value: "action",
                },
            ],
            headers_mobile: [
                {
                    text: "#",
                    value: "id",
                    sortable: true,
                },
                {
                    text: "Nombre",
                    value: "nombre_comercial",
                    sortable: false,
                },
                { text: "Estado", value: "estado.nombre", sortable: false },
                {
                    text: "Producto interesado",
                    value: "interesado.nombre",
                    sortable: false,
                },
            ],
            cliente: {
                cif: null,
                razon_social: "",
                nombre_comercial: "",
            },

            Clientes: [],
            selectedItem: 0,
            dialog_comercial: false,
            dialog: false,
            rol: 0,
            isMobile: false,

            agentes: [],
            conocido: [
                { id: 1, nombre: "Airclos" },
                { id: 2, nombre: "Empresa/Marca" },
                { id: 3, nombre: "Gimenez Ganga" },
                { id: 4, nombre: "Habitual (ya cliente)" },
                { id: 5, nombre: "Lumon España" },
            ],
            productos: [
                { id: 1, nombre: "Aluminio - Carpintería Metálica" },
                { id: 2, nombre: "Aluminio/PVC" },
                { id: 3, nombre: "Bioclimática" },
                { id: 4, nombre: "Cerrajería" },
                { id: 5, nombre: "CSP" },
            ],
            savedSortBy: null,
            savedSortDesc: null,
        };
    },
    mounted() {
        this.checkMobileView();
        // Listen for window resize events
        window.addEventListener("resize", this.checkMobileView);
    },
    beforeDestroy() {
        // Remove the resize event listener when the component is destroyed
        window.removeEventListener("resize", this.checkMobileView);
    },

    created() {
        this.getEstadosPotencial();
        this.rol = localStorage.getItem("role");
        this.getAgentes();

        this.getClientes();
    },
    watch: {
        filtros_prueba: {
            deep: true,
            handler: function (val) {
                //console.log(val);
            },
        },
        "$route.meta.rol": function (val) {
            this.getClientes();
        },
        "filtros.validacion": function (val) {
            this.getClientes();
        },
        filterString: debounce(function (val) {
            this.getClientes();
        }, 500),
    },
    methods: {
        ExportExcel() {
            let filtros = this.filterString;

            axios
                .get(
                    `/api/excel-cliente?rol=${this.$route.meta.rol}${filtros}`,
                    { responseType: "blob" }
                )
                .then((response) => {
                    const downloadUrl = window.URL.createObjectURL(
                        new Blob([response.data])
                    );
                    const link = document.createElement("a");
                    link.href = downloadUrl;
                    link.setAttribute("download", "clientes.xlsx");
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                })
                .catch((error) => {
                    console.error("Error exporting clientes:", error);
                });
        },
        checkMobileView() {
            this.isMobile = window.innerWidth <= 768; // Set the breakpoint value as per your needs
        },
        onOptionsUpdate(options) {
            if (options.sortBy.length > 0) {
                this.savedSortBy = options.sortBy;
                this.savedSortDesc = options.sortDesc;
                //console.log(this.savedSortDesc);
                this.getClientes();
                // Execute your custom fun
            }
        },
        handleClick(value) {
            this.$router.push(`/${this.formpath}?id=${value.id}`);
            //console.log(value);
        },
        obtenerConocido(item) {
            let nombre = "";
            this.conocido.forEach((element) => {
                if (element.id == item.id) {
                    nombre = element.nombre;
                }
            });
            return nombre;
        },
        obtenerInteres(item) {
            let nombre = "";
            this.productos.forEach((element) => {
                if (element.id == item.id) {
                    nombre = element.nombre;
                }
            });
            return nombre;
        },
        showBusqueda() {
            this.show_busqueda = true;
        },
        getEstadosPotencial() {
            axios.get(`api/get-estados-potencial`).then(
                (res) => {
                    this.filter_headers[2].items = res.data;
                },
                (res) => {}
            );
        },
        getAgentes() {
            axios.get(`api/get-agentes`).then(
                (res) => {
                    this.filter_headers[1].items = [
                        ...[{ id: 0, nombre: "Sin Asignar" }],
                        ...res.data.Agentes,
                    ];
                    this.agentes = [
                        ...[{ id: 0, nombre: "Sin Asignar" }],
                        ...res.data.Agentes,
                    ];
                },
                (res) => {}
            );
        },
        getRowClass(item) {
            if (item.agente)
                if (item.agente.estadistica == 0) {
                    return "yellow";
                }

            return "pointer";
        },
        downloadFile(response) {
            let blob = new Blob([response.data], { type: "xlsx" }),
                downloadUrl = window.URL.createObjectURL(blob),
                filename = "",
                disposition = response.headers["content-disposition"];

            if (disposition && disposition.indexOf("attachment") !== -1) {
                let filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/,
                    matches = filenameRegex.exec(disposition);

                if (matches != null && matches[1]) {
                    filename = matches[1].replace(/['"]/g, "");
                }
            }

            let a = document.createElement("a");
            if (typeof a.download === "undefined") {
                window.location.href = downloadUrl;
            } else {
                a.href = downloadUrl;
                a.download = filename;
                document.body.appendChild(a);
                a.click();
            }
        },
        exportAll() {
            axios
                .get("/api/export-clientes", {
                    responseType: "blob",
                })
                .then((response) => {
                    this.downloadFile(response);
                })
                .catch(error);
        },
        exportSelected() {
            let ids = [];
            this.selected.forEach((elemento) => {
                ids.push(elemento.id);
            });
            axios
                .post(
                    "/api/export-clientes",
                    { ids: ids },
                    {
                        responseType: "blob",
                    }
                )
                .then((response) => {
                    this.downloadFile(response);
                })
                .catch(error);
        },
        exportFiltered() {
            let ids = [];

            axios
                .post(
                    "/api/export-clientes-filtered",
                    { agente: this.filtros.id_agente },
                    {
                        responseType: "blob",
                    }
                )
                .then((response) => {
                    this.downloadFile(response);
                })
                .catch(error);
        },
        EliminarSeleccionados() {
            let ids = [];
            this.selected.forEach((elemento) => {
                ids.push(elemento.id);
            });
            axios.post(`api/delete-clientes`, { ids: ids }).then(
                (res) => {
                    this.getClientes();
                    this.selected = [];
                    this.$toast.sucs("Clientes eliminados con éxito");
                },
                (res) => {
                    this.$custom_error("Error eliminando los clientes");
                }
            );
        },
        ChangeSize(event) {
            this.cantidad = event;
            this.getClientes();
            //console.log(`evento: ${event}`);
        },
        ChangePage(event) {
            this.page = event.page;
            this.getClientes();
            //console.log(event);
        },
        async getClientes() {
            this.loading = true;
            let filtros = this.filterString;
            try {
                const res = await axios.get(
                    `api/peticiones?page=${this.page}&amount=${this.cantidad}${filtros}`
                );
                this.Clientes = res.data.data;
                console.log(this.Clientes);
                this.total_cliente = res.data.total;
                this.loading = false;
            } catch (err) {
                this.$custom_error("Error consultando los clientes");
                this.loading = false;
            }
        },
        checkCliente() {
            axios.post(`api/check-cliente-comercial`, this.cliente).then(
                (res) => {
                    //console.log(res.data);
                    if (res.data.status) {
                        this.$router.push(
                            `${this.formpath}?rs=${this.cliente.razon_social}&cif=${this.cliente.cif}&nombre=${this.cliente.nombre_comercial}`
                        );
                    } else {
                        this.$custom_error(res.data.msg);
                    }
                },
                (res) => {
                    this.$custom_error("Error consultando el cliente");
                }
            );
        },
        openModal(item) {
            this.selectedItem = this.Clientes.indexOf(item);
            this.dialog = true;
        },
        openModalComercial(item) {
            this.dialog_comercial = true;
        },
        deleteUser() {
            axios
                .post("api/delete-cliente", {
                    id: this.Clientes[this.selectedItem].id,
                })
                .then(
                    (res) => {
                        this.$toast.sucs("Cliente eliminado con éxito");
                        this.dialog = false;
                        this.getClientes();
                    },
                    (err) => {
                        this.$custom_error("Error eliminando el cliente");
                    }
                );
        },
    },
    filters: {},
    components: {
        BusquedaCliente,
        FilterComponentVue,
    },
    computed: {
        formpath: function () {
            return `guardar-${
                this.$route.meta.rol == 1 ? "potencial" : "cliente"
            }`;
        },
        isloading: function () {
            // return this.$store.getters.getloading
        },
    },
};
</script>
